(() => {
  if (customElements.get('section-lazy-loader')) return;

  class SectionLazyLoader extends HTMLElement {
    constructor() {
      super();

      this.id = this.getAttribute('data-id');

      this.intersectionObserver = null;
    }

    connectedCallback() {
      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            this.loadSection();
            this.intersectionObserver.disconnect();
          }
        },
        {
          rootMargin: '400px',
        }
      );

      this.intersectionObserver.observe(this);
    }

    async loadSection() {
      const url = new URL(window.location);
      url.searchParams.set('section_id', this.id);
      const response = await fetch(url);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const section = doc.querySelector(`section-lazy-loader[data-id="${this.id}"]`);

      if (section) {
        this.innerHTML = section.innerHTML;
        this._executeScripts();
      }
    }

    _executeScripts() {
      this.querySelectorAll('script').forEach((script) => {
        const newScript = document.createElement('script');
        Array.from(script.attributes).forEach((attr) => newScript.setAttribute(attr.name, attr.value));
        newScript.appendChild(document.createTextNode(script.innerHTML));
        script.parentNode.replaceChild(newScript, script);
      });
    }
  }

  customElements.define('section-lazy-loader', SectionLazyLoader);
})();
